@import 'styles/mixins';
@import 'styles/variables';

.list {
  display: flex;
  padding: 3px 0px 3px 5px;
  align-items: center;
  gap: 5px;
}
